import React from 'react';
import classes from './Input.module.css';

function TextArea({ ...rest }) {
  return <textarea className={classes.textarea} {...rest} />;
}

export default TextArea
